(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/after-payment-dialog.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/after-payment-dialog.js');

'use strict';

function afterPayment(_ref) {
  let {
    productName,
    totalCost,
    next
  } = _ref;
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'nav-my-games',
    title: "".concat(productName, " f\xF6r ").concat(totalCost, " kr \xE4r betald"),
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Insättningen och betalningen lyckades och du kan börja skrapa din lott.'
    }],
    actions: [{
      title: 'Spela nu',
      callback: (e, forms, dialog) => {
        dialog.close();
        next === null || next === void 0 || next();
      }
    }]
  }));
}
setGlobal('svs.ticketgames.ticketUtility.utils.afterPayment', afterPayment);

 })(window);